export enum RefreshJobEventTypeEnum {
  RefreshHistory = 1,
}
